
define('text!common/views/commercial/creatives/logo-link.html',[],function () { return '<a href="<%=clickMacro%><%=logoUrl%>" class="ad-slot--paid-for-badge__link">\n    <img class="ad-slot--paid-for-badge__logo" src="<%=logoImage%>" />\n</a>\n';});

